import { cn } from "@/lib/utils";

import { AppStoreIcon, PlayStoreIcon } from "./icons";

export const StoreEnum = {
  APPLE: "APPLE",
  GOOGLE: "GOOGLE",
} as const;
export type StoreEnum = (typeof StoreEnum)[keyof typeof StoreEnum];

export const ThemeEnum = {
  DARK: "DARK",
  LIGHT: "LIGHT",
} as const;
export type ThemeEnum = (typeof ThemeEnum)[keyof typeof ThemeEnum];

const STORE_CONFIG = {
  [StoreEnum.APPLE]: {
    className: "px-[17px] py-2",
    Icon: AppStoreIcon,
    label: "Download on the App Store",
    url: "https://link.morty.app/SpnYdIwEJhb",
  },
  [StoreEnum.GOOGLE]: {
    className: "p-2",
    Icon: PlayStoreIcon,
    label: "Download on the Play Store",
    url: "https://link.morty.app/acKIXamYfhb",
  },
};

const THEME_CONFIG = {
  [ThemeEnum.DARK]: {
    button: "bg-black shadow-black/50",
    icon: "text-white",
  },
  [ThemeEnum.LIGHT]: {
    button: "bg-white shadow-white/50",
    icon: "text-charcoal",
  },
};

export interface AppStoreButtonProps extends React.ComponentProps<"a"> {
  className?: string;
  iconClassName?: string;
  store?: StoreEnum;
  theme?: ThemeEnum;
}

export default function AppStoreButton({
  className,
  iconClassName,
  store = StoreEnum.APPLE,
  theme = ThemeEnum.LIGHT,
  ...props
}: AppStoreButtonProps) {
  const { Icon, ...storeConfig } = STORE_CONFIG[store];
  const themeConfig = THEME_CONFIG[theme];

  return (
    <a
      aria-label={storeConfig.label}
      className={cn(
        "flex h-[50px] items-center justify-center rounded-sm px-2 transition-shadow hover:shadow-0-0-10",
        storeConfig.className,
        themeConfig.button,
        className
      )}
      href={storeConfig.url}
      rel="noopener noreferrer"
      target="_blank"
      {...props}
    >
      <Icon className={cn(themeConfig.icon, iconClassName)} />
    </a>
  );
}
